import common from "@page/common/js/common";
import RenderProductPageContent from "@page/productPage/js/ProductPageContent";

genquo.productConfig = {
	customFeaturedSlider: true,
	sizeSelectorTypeDesktop: "modelAndItem",
	imageBasePath: "https://image.genquo.tw/",
	zoomboxData: "ModelImage",
	moreJumboImage: ".product-photos__model",
	imageRenderType: "sliceFirst",
	refreshDOMs: [".product-photos__jumbo", ".product-photos__model", ".product-photos__item", ".product-size"],
};

RenderProductPageContent();
